import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from "@angular/core";
import './checkbox-cell.component.scss';

@Component({
    selector: 'checkbox-cell',
    template: require('./checkbox-cell.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxCell {
    @Input() data: boolean;
    @Input() disabled: boolean;
    @Output() cellClick = new EventEmitter<PointerEvent>();

    @HostListener('click', ['$event'])
    onClick(event: PointerEvent): void {
        this.cellClick.emit(event);
    }

    constructor() { }
}
